import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-generic-error-dialog',
    templateUrl: './generic-error-dialog.html'
})
export class GenericErrorDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<GenericErrorDialogComponent>,
        public loc: LocalizationService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(): void {
        this.dialogRef.close();
    }

    backToWishList() {
        window.location.replace(environment.backToWishListUrl);
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/generic-error-dialog/generic-error-dialog.ts